/**
 * The three-way closing call to action on Get involved.
 *
 * One card per audience, never a single generic button. This is the committed
 * copy; the page renders the cards saved on its "In summary" section, and falls
 * back to these when the database has not been seeded.
 */

export type CTAOption = {
  title: string;
  description: string;
  href: string;
  action: string;
};

export const finalCtaFallback: CTAOption[] = [
  {
    title: "Support our work",
    description:
      "For foundations, INGOs, embassies, development agencies and companies looking for a delivery partner in Nepal.",
    href: "/get-involved/support",
    action: "Explore support options",
  },
  {
    title: "Volunteer",
    description:
      "Contribute skills and time to live programme work, or join a Charity Trek that combines trekking with service.",
    href: "/get-involved/volunteer",
    action: "See how volunteering works",
  },
  {
    title: "Work with us locally",
    description:
      "For schools, wards, health posts, community-based organisations and local groups proposing joint work.",
    href: "/contact",
    action: "Propose local collaboration",
  },
];
